'use client'

import {type BankFeeCalculatorProps} from './types'
import {bankFeeCalculatorFormSchema} from './constants'
import {DEFAULT_FORM_STATE} from './_components/InputForm/constants'
import {useQueryState, parseAsJson} from 'nuqs'
import BankFeeCalculatorStateless from './stateless'
import {useEffect, useState} from 'react'

const BankFeeCalculator = ({
  mercuryFeeConstants,
  legacyBankFeeConstants,
  annualSavingsCaption,
}: BankFeeCalculatorProps) => {
  const [formState, setFormState] = useQueryState(
    'formData',
    parseAsJson(bankFeeCalculatorFormSchema.parse).withDefault(DEFAULT_FORM_STATE)
  )
  const [isCopied, setIsCopied] = useState(false)

  useEffect(() => {
    if (!isCopied) return

    const timeout = setTimeout(() => {
      setIsCopied(false)
    }, 2000)

    return () => clearTimeout(timeout)
  }, [isCopied])

  const handleFormChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {name, value} = e.target
    const numericValue = value ? Number(value.replace(/\D/g, '')) : null
    setFormState(prev => ({
      ...prev,
      [name]: numericValue,
    }))
  }

  return (
    <BankFeeCalculatorStateless
      formState={formState}
      onFormChange={handleFormChange}
      mercuryFeeConstants={mercuryFeeConstants}
      legacyBankFeeConstants={legacyBankFeeConstants}
      annualSavingsCaption={annualSavingsCaption}
      isCopied={isCopied}
      setIsCopied={setIsCopied}
    />
  )
}

export default BankFeeCalculator
